import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const companyApi = createApi({
    reducerPath: 'companyApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        addWebHookUrl: builder.mutation({
            query: (payload) => ({
                url: 'company/webhook',
                method: 'POST',
                body: payload
            })

        }),
        getCompanySettings: builder.mutation({
            query: () => ({
                url: 'company/settings',
                method: 'GET'
            })
        }),
        updateCompanySettings: builder.mutation({
            query: (payload) => ({
                url: 'company/settings',
                method: 'PUT',
                body: payload
            })
        })
    })
})

export const { useAddWebHookUrlMutation, useGetCompanySettingsMutation, useUpdateCompanySettingsMutation } = companyApi;
